import service from './RestService';
import { RestResponse } from '../types/response/RestResponse';
import { DeliveryZones, Transport } from '../state/zones/types';

const path = '/zones';

export enum ZoneMode {
  Edit = 'Edit',
  Create = 'Create'
}

const getZoneSettings = (mode: ZoneMode, id?: number) => ({
  service: mode === ZoneMode.Create ? service.post : service.put,
  path: mode === ZoneMode.Create ? `${path}` : `${path}/${id}`
});

class UsersService {
  getMeansOfTransport = (): RestResponse<Transport[]> => service.get(`${path}/means-of-transport`);

  getDeliveryZones = (projectId: number, onlyActive: boolean): RestResponse<DeliveryZones> =>
    service.get(`${path}/by-project/${projectId}/${onlyActive}`);

  manageDeliveryZone = (
    projectId: number,
    active: boolean,
    name: string,
    address: string,
    barrierSystemStatus: boolean,
    equipmentId: number,
    mode: ZoneMode,
    deliveryZoneId?: number,
    barrierDeviceId?: number
  ): RestResponse<null> => {
    const settings = getZoneSettings(mode, deliveryZoneId);
    return settings.service(settings.path, { projectId, active, name, address, barrierSystemStatus, equipmentId, barrierDeviceId });
  };
}

export default new UsersService();
